import React from 'react';
import { FadeIn } from './FadeIn';
import { Monitor, Package, Truck, Search, Upload, BarChart3, Megaphone, Wrench } from 'lucide-react';
export function QueAprenderas() {
  const modules = [{
    number: '01',
    icon: Monitor,
    title: 'Introducción a Amazon Seller Central',
    description: 'Conoce el panel principal donde se gestiona todo tu negocio dentro de Amazon.'
  }, {
    number: '02',
    icon: Package,
    title: 'Cómo funciona Amazon FBA desde cero',
    description: 'Aprende el modelo logístico de Amazon: envías, ellos almacenan y entregan.'
  }, {
    number: '03',
    icon: Truck,
    title: 'Cómo funciona Amazon FBM desde cero',
    description: 'Vende con más control, sin almacenar en bodegas FBA y con flexibilidad total.'
  }, {
    number: '04',
    icon: Search,
    title: 'Cómo encontrar productos ganadores',
    description: 'Estrategias prácticas para detectar productos con demanda real y rentabilidad.'
  }, {
    number: '05',
    icon: Upload,
    title: 'Cómo publicar productos correctamente',
    description: 'Aprende a crear listings optimizados que conviertan y se posicionen mejor.'
  }, {
    number: '06',
    icon: BarChart3,
    title: 'Cómo analizar oportunidades reales',
    description: 'Mide demanda, competencia y márgenes antes de invertir en cada producto.'
  }, {
    number: '07',
    icon: Megaphone,
    title: 'Cómo manejar campañas publicitarias',
    description: 'Configura, optimiza y escala campañas dentro de Amazon Seller.'
  }, {
    number: '08',
    icon: Wrench,
    title: 'Recursos y herramientas para vender mejor',
    description: 'Aprende herramientas prácticas para investigar productos, analizar oportunidades y optimizar mejor tu proceso de ventas dentro de Amazon.'
  }];
  return <section className="bg-brand-white py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-686">
      {/* Subtle background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40" data-id="element-687">
        <div className="absolute top-1/3 left-0 w-[500px] h-[500px] bg-brand-gold/5 rounded-full blur-3xl" data-id="element-688"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl" data-id="element-689"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-690">
        <FadeIn data-id="element-691">
          <div className="text-center mb-14 md:mb-20 max-w-3xl mx-auto" data-id="element-692">
            <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-brand-gold mb-4" data-id="element-693">
              ✨ Contenido del sistema
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green leading-[1.05] tracking-tight mb-5" data-id="element-694">
              ¿Qué aprenderás dentro del sistema?
            </h2>
            <p className="text-base md:text-lg text-brand-text/70 leading-relaxed" data-id="element-695">
              Aprende paso a paso cómo funciona realmente el ecosistema de
              ventas dentro de Amazon — incluso si estás comenzando desde cero.
            </p>
          </div>
        </FadeIn>

        {/* Modules grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" data-id="element-696">
          {modules.map((m, index) => {
          const Icon = m.icon;
          return <FadeIn key={index} delay={0.04 * (index % 8)} data-id="element-697">
                <div className="group relative h-full bg-white border border-brand-text/8 rounded-2xl p-6 md:p-7 shadow-[0_2px_24px_-10px_rgba(0,0,0,0.08)] hover:shadow-[0_25px_50px_-15px_rgba(28,57,40,0.18)] hover:-translate-y-1 hover:border-brand-gold/30 transition-all duration-300 overflow-hidden" data-id="element-698">
                  {/* Module number watermark */}
                  <span className="absolute top-4 right-5 text-5xl md:text-6xl font-bold text-brand-green/5 leading-none select-none" data-id="element-699">
                    {m.number}
                  </span>

                  {/* Icon */}
                  <div className="relative w-12 h-12 rounded-xl bg-brand-green/8 group-hover:bg-brand-gold/15 flex items-center justify-center mb-5 transition-colors" data-id="element-700">
                    <Icon className="w-6 h-6 text-brand-green" strokeWidth={2} data-id="element-701" />
                  </div>

                  {/* Module label */}
                  <p className="relative text-[10px] font-bold uppercase tracking-[0.18em] text-brand-gold mb-2" data-id="element-702">
                    Módulo {m.number}
                  </p>

                  {/* Title */}
                  <h3 className="relative text-base md:text-lg font-bold text-brand-green mb-2.5 leading-snug" data-id="element-703">
                    {m.title}
                  </h3>

                  {/* Description */}
                  <p className="relative text-sm text-brand-text/65 leading-relaxed" data-id="element-704">
                    {m.description}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}